import React, { useState, useEffect } from 'react';
import ArchitectureView from './ArchitectureView';
import MobileArchitectureView from './MobileArchitectureView';

export default function ArchitectureViewResponsive() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check initial screen size
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // Using 768px as mobile breakpoint
    };

    // Check on mount
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // You can also check for touch capability as an additional factor
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Use mobile view if screen is small OR device has touch and screen is medium
  const shouldUseMobile = isMobile || (hasTouch && window.innerWidth < 1024);

  return shouldUseMobile ? <MobileArchitectureView /> : <ArchitectureView />;
}